module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/english.json
// module id = 304
// module chunks = 90583938598319